import { Field, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';
import { useSelector } from 'react-redux';
import { pipe } from 'rxjs';
import WholePortionAssociatedMoistureContentSection from './WholePortionAssociatedMoistureContentSection';
import WholePortionWetPreparationMultiTraySection from './WholePortionWetPreparationMultiTraySection';
import WholePortionWetPreparationSingleTraySection from './WholePortionWetPreparationSingleTraySection';

const WholePortionWetPreparationSectionBase: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const initialSeparationPerformed: boolean = useSelector(
    createWorksheetSelector!('data.Preparation.InitialSeparationPerformed', false)
  );

  const singleTray = useSelector(
    pipe(createWorksheetSelector!('Masses.MassMeasurement.WetMassMeasurements'), (p) => p?.length < 2)
  );

  return (
    <>
      <NamePrefixModifier appendNamePrefix="Masses">
        {singleTray ? <WholePortionWetPreparationSingleTraySection /> : <WholePortionWetPreparationMultiTraySection />}

        {!initialSeparationPerformed && (
          <WholePortionAssociatedMoistureContentSection heading="Total Material Water Content" />
        )}
        <ListFieldSection>
          <Field input={<TextOutput />} name="DryMass" />
        </ListFieldSection>
      </NamePrefixModifier>
    </>
  );
};
const WholePortionWetPreparationSection = withInjectedProps(WholePortionWetPreparationSectionBase);

export { WholePortionWetPreparationSection };
export default WholePortionWetPreparationSection;
